module.exports = __webpack_public_path__ + "static/media/maxParties_25_50.a2945c90.png";